import { Link } from "react-router-dom";
import SpotlightCard from "@/components/SpotlightCard";
interface FeatureCardProps {
  icon: string;
  title: string;
  description: string;
  spotlightColor?: `rgba(${number}, ${number}, ${number}, ${number})`;
  link?: string;
}
const FeatureCard: React.FC<FeatureCardProps> = ({
  icon,
  title,
  description,
  spotlightColor = "rgba(0, 229, 255, 0.2)",
  link
}) => {
  const inner = (
    <SpotlightCard
      className="h-full hover:scale-[1.02] hover:-translate-y-1 transition-all duration-300"
      spotlightColor={spotlightColor}
    >
      <div className="flex flex-col h-full gap-6">
        <div className="w-16 h-16 rounded-2xl bg-[#00d9d9]/10 border border-[#00d9d9]/20 flex items-center justify-center shrink-0">
          <img
            src={icon}
            alt={title}
            className="w-9 h-9 object-contain"
          />
        </div>
        <div className="flex flex-col gap-3 flex-grow">
          <h3 className="text-xl font-semibold text-white leading-snug">{title}</h3>
          <p className="text-white/50 text-base leading-relaxed">{description}</p>
        </div>
        {link && (
          <div className="flex items-center gap-1 text-[#00d9d9] text-sm font-medium mt-auto">
            Μάθε περισσότερα
            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </div>
        )}
      </div>
    </SpotlightCard>
  );
  return link ? <Link to={link} className="block h-full">{inner}</Link> : inner;
};
export default FeatureCard;
